<template>
	<section :class="['header-patient']">
		<div class="header-patient__options">
			<slot></slot>
		</div>
		<div class="header-patient__content">
			<div class="header-patient__info">
				<h1 class="header-patient__h1">Patient <span>{{ patient.name }}</span></h1>
				<h2 class="header-patient__h2">{{ subtitle }}</h2>
			</div>
			<avatar class="sk-avatar-margin" :src="patient.picture" :name="patient.name" />
		</div>
	</section>
</template>

<script>
import Avatar from '@/modules/ui/Avatar'
export default {
	name: 'header-patient',
	props: {
		title: {
			type: String,
			default: 'IDICARE'
		},
		subtitle: {
			type: String,
			default: 'We care about your well-being. Leading Innovation in Health Aid Tecnhologies.'
		},
		patient: {
			type: Object
		}
	},
	components: {
		Avatar,
	}
}
</script>

<style scoped>
.header-patient {
	display: flex;
	padding: 0 0 35px 0;
}
.header-patient__content {
	display: flex;
	align-items: center;
}
.header-patient__info {
	padding: 0 20px;
}
.header-patient__h1 {
	color: var(--main-color);
	font-size: 24px;
	font-weight: 900;
	border: 0;
	padding: 0;
	margin: 0;
	text-align: right;
}
.header-patient__h1 > span {
	color: #333;
}
.header-patient__h2 {
	color: #aaa;
	font-size: 12px;
	font-weight: 400;
	border: 0;
	padding: 0;
	margin: 5px 0 0 0;
	text-align: right;
}
.header-patient__options {
	display: flex;
	align-items: center;
	flex: 1;
}
@media (max-width: 900px) {
	.header-patient {
		flex-direction: column-reverse;
	}
	.header-patient__content {
		display: flex;
		flex-direction: row-reverse;
		justify-content: flex-end;
	}
	.header-patient__h1 {
		text-align: left;
	}
	.header-patient__h2 {
		text-align: left;
	}
	.header-patient__options {
		padding: 25px 0 0 0;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/HeaderPatient.vue